import { CASE_TYPE_MAP } from '@demandproai/shared';
import { useProductContext } from '../contexts/ProductContext';

const useCaseTypeOptions = () => {
  const { CASE_TYPE_OPTIONS_MT } = useProductContext();

  return CASE_TYPE_OPTIONS_MT ?? Object.values(CASE_TYPE_MAP);
};

export default useCaseTypeOptions;
